/**
 * Api documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GeoStatusDisplayDTO } from './geoStatusDisplayDTO';
import { GeoAlertDTO } from './geoAlertDTO';
import { GeoTestRegionDetailDTO } from './geoTestRegionDetailDTO';
import { GeoTestMetricsDTO } from './geoTestMetricsDTO';
import { GeoTacticTableRowDTO } from './geoTacticTableRowDTO';
import { GeoCampaignDTO } from './geoCampaignDTO';
import { GeoTestPermissionsDTO } from './geoTestPermissionsDTO';
import { GeoTestImplementationSwitchDTO } from './geoTestImplementationSwitchDTO';
import { GeoTestScheduleDTO } from './geoTestScheduleDTO';


export interface GeoTestDetailResponseDTO { 
    /**
     * Unique identifier of the geo test study
     */
    testId: number;
    /**
     * User-defined name for the geo test
     */
    testName: string;
    /**
     * Optional business question the test is designed to answer
     */
    businessQuestion?: string;
    /**
     * Current status of the geo test (DRAFT, ACTIVE, PAUSED, COMPLETED, etc.)
     */
    status: GeoTestDetailResponseDTO.StatusEnum;
    /**
     * Test cell configuration ID used by the results API to identify the treatment cell
     */
    testCellConfigId: number;
    /**
     * BAU (business-as-usual) cell configuration ID used by the results API to identify the control cell
     */
    bauCellConfigId: number;
    displayStatus?: GeoStatusDisplayDTO;
    /**
     * Type of geo test (incrementality or scale)
     */
    testType: GeoTestDetailResponseDTO.TestTypeEnum;
    /**
     * Execution method for the test (MANAGED or SELF_SERVE)
     */
    implementation: GeoTestDetailResponseDTO.ImplementationEnum;
    /**
     * Whether the study uses partial automatic implementation (cp_doe_study_config.implementationType is PARTIAL_AUTO)
     */
    isPartialAuto: boolean;
    /**
     * List of selected tactic identifiers included in the test
     */
    selectedTacticIds: Array<string>;
    /**
     * Enriched tactic data with formatted metrics from ElasticSearch
     */
    selectedTactics?: Array<GeoTacticTableRowDTO>;
    /**
     * List of conversion type IDs measured in the test
     */
    conversionTypeIds: Array<number>;
    /**
     * Human-readable names for the selected conversion types
     */
    conversionTypeNames: Array<string>;
    /**
     * Map of conversion types including parent and child study conversion types with IDs and names
     */
    conversionTypesMap?: object;
    testRegions: GeoTestRegionDetailDTO;
    /**
     * List of campaigns included in the test with spend and configuration data
     */
    campaigns: Array<GeoCampaignDTO>;
    testSchedule?: GeoTestScheduleDTO;
    metrics: GeoTestMetricsDTO;
    /**
     * Currency code for monetary values (e.g. USD, EUR)
     */
    currencyCode?: string;
    /**
     * Composite data source ID for the platform vendor configuration
     */
    compositeDataSourceId?: number;
    permissions: GeoTestPermissionsDTO;
    implementationSwitch?: GeoTestImplementationSwitchDTO;
    /**
     * Email or username of the user who created the test
     */
    createdBy: string;
    /**
     * ISO-8601 timestamp when the test was created
     */
    createdAt: string;
    /**
     * Email or username of the user who last modified the test
     */
    modifiedBy: string;
    /**
     * ISO-8601 timestamp when the test was last modified
     */
    modifiedAt: string;
    /**
     * KPI type classification (e.g. PRIMARY, SECONDARY) for multi-KPI tests
     */
    kpiType?: string;
    /**
     * History of KPI state transitions for multi-KPI test lifecycle tracking
     */
    kpiStateHistory?: string;
    /**
     * Primary study ID for child tests in a multi-KPI test group
     */
    multiKpiPrimaryStudyId?: number;
    /**
     * Parent test ID if this test is a child in a multi-KPI group
     */
    parentId?: number;
    /**
     * Whether this test is the parent in a multi-KPI test group
     */
    isMultiKpiParent?: boolean;
    /**
     * Child test details for multi-KPI tests, one per additional conversion type
     */
    childTests?: Array<GeoTestDetailResponseDTO>;
    /**
     * Active alert notifications for the test (contamination warnings, schedule conflicts, etc.)
     */
    alerts?: Array<GeoAlertDTO>;
}
export namespace GeoTestDetailResponseDTO {
    export type StatusEnum = 'DRAFT' | 'ACTIVE' | 'INACTIVE';
    export const StatusEnum = {
        Draft: 'DRAFT' as StatusEnum,
        Active: 'ACTIVE' as StatusEnum,
        Inactive: 'INACTIVE' as StatusEnum
    };
    export type TestTypeEnum = 'Holdout' | 'Scale' | 'Contribution';
    export const TestTypeEnum = {
        Holdout: 'Holdout' as TestTypeEnum,
        Scale: 'Scale' as TestTypeEnum,
        Contribution: 'Contribution' as TestTypeEnum
    };
    export type ImplementationEnum = 'AUTOMATIC' | 'MANUAL';
    export const ImplementationEnum = {
        Automatic: 'AUTOMATIC' as ImplementationEnum,
        Manual: 'MANUAL' as ImplementationEnum
    };
}


